import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Divider, FormControl, Grid, InputLabel, ListItemIcon, ListItemText, MenuItem, Paper, Select, Tooltip } from '@mui/material';
import DateComponent from 'CommonComponents/DateComponent';
import { callGetEvents, getCallGetEventsLoader } from 'APILayer/ManuDashboardAPIs/ApiGetEvents';
import LocationCameraSelect from 'CommonComponents/LocationCameraSelect';
import CachedIcon from '@mui/icons-material/Cached';
import { setCameraSelected } from 'Redux/DashboardVariables';
import { setLocationSelected } from 'Redux/DashboardVariables';
import { getRuntimeEventsLoader } from 'APILayer/ManuDashboardAPIs/ApiGetRuntimeEvents';
import ScaleLoader from "react-spinners/ScaleLoader";
import { getAllIncidents } from 'Redux/DashboardVariables';
import { makeStyles } from '@mui/styles';
import { setSelectedIncidents } from 'Redux/FilterVariables';
import { setAutoRefreshTime } from 'Redux/DashboardVariables';
import { getAutoRefreshTime } from 'Redux/DashboardVariables';

const useStyles = makeStyles((theme) => ({
  formControl: {
    // margin: theme.spacing(1),
    width: 300
  },
  indeterminateColor: {
    color: "green"
  },
  selectAllText: {
    fontWeight: 500
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)"
    }
  }
}));

const TopBarFilterOne = () => {
  const dispatch = useDispatch();
  const intervalId = useRef(null);

  const incidentList = useSelector(getAllIncidents).topBarDropdownEvents;
  const autoRefreshTime = useSelector(getAutoRefreshTime);

  const runtimeEventsLoader = useSelector(getRuntimeEventsLoader);
  const getEventsLoader = useSelector(getCallGetEventsLoader);

  const classes = useStyles();
  const [selected, setSelected] = useState(incidentList);
  const isAllSelected =
    incidentList.length > 0 && selected.length === incidentList.length;

  const handleAutoRefreshTimer = () => {
    clearInterval(intervalId.current);
    const tempTimerId = setInterval(() => {
      dispatch(callGetEvents({ resetSearchDate: true }));
    }, autoRefreshTime * 1000);
    intervalId.current = tempTimerId;
  }

  useEffect(() => {
    if (autoRefreshTime) {
      handleAutoRefreshTimer();
    } else {
      clearInterval(intervalId.current);
    }

  }, [autoRefreshTime]);

  useEffect(() => {
    clearInterval(intervalId.current);
    return () => clearInterval(intervalId.current);
  }, [])

  const handleChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setSelected(selected.length === incidentList.length ? [] : incidentList);
      dispatch(setSelectedIncidents(selected.length === incidentList.length ? [] : incidentList));
      return;
    }
    setSelected(value);
    dispatch(setSelectedIncidents(value));
  };

  const resetFilters = () => {
    dispatch(setLocationSelected(''));
    dispatch(setCameraSelected(''));
  }

  // console.log('main log top bar filter two: ', abortControllerArrRef.current);

  return (
    <Paper elevation={0} style={{ padding: '10px 0', marginTop: '10px', display: 'flex' }}>
      <Fragment>
        <DateComponent />
        {runtimeEventsLoader || getEventsLoader
          ?
          <Button
            style={{
              margin: '10px 0',
              color: 'white',
              backgroundColor: '#45BF9F',
              boxShadow: 'none',
              width: '120px',
              textTransform: 'none'
            }}
          >
            <ScaleLoader
              height={16}
              width={4}
              radius={4}
              margin={2}
              // style={{ marginTop: "2px" }}
              color={"white"}
            />
          </Button>
          :
          <Button
            style={{
              margin: '10px 0',
              color: 'white',
              backgroundColor: '#45BF9F',
              boxShadow: 'none',
              width: '120px',
              textTransform: 'none',
              fontFamily: 'Lato'
            }}
            onClick={() => dispatch(callGetEvents({}))}
          >
            Query Data
          </Button>
        }
        <Divider orientation="vertical" flexItem style={{ margin: "0 5px 0 10px" }} />

      </Fragment>

      <LocationCameraSelect style={{ margin: '10px 5px' }} />

      <Grid xs={2} item style={{ margin: "10px 5px 10px 5px" }}>
        <FormControl size="small" variant="outlined" fullWidth>
          <InputLabel id="mutiple-select-label">Select Events</InputLabel>
          <Select
            labelId="mutiple-select-label"
            multiple
            value={selected}
            onChange={handleChange}
            renderValue={(selected) => selected.join(", ")}
            // MenuProps={MenuProps}
            label="Filter by event"
            style={{ background: "white", width: '235px' }}
            inputProps={{
              name: "Filter by event",
              id: "outlined-age-native-simple",
              style: { padding: "12px" },
            }}
          >
            <MenuItem
              value="all"
              classes={{
                root: isAllSelected ? classes.selectedAll : ""
              }}
            >
              <ListItemIcon>
                <Checkbox
                  sx={{
                    color: '#45BF9F',
                    '&.Mui-checked': {
                      color: '#45BF9F',
                    }
                  }}
                  checked={isAllSelected}
                  indeterminate={
                    selected.length > 0 && selected.length < incidentList.length
                  }
                />
              </ListItemIcon>
              <ListItemText
                classes={{ primary: classes.selectAllText }}
                primary="Select All"
              />
            </MenuItem>
            {incidentList.sort().map((option, index) => (
              <MenuItem key={index} value={option}>
                <ListItemIcon>
                  <Checkbox
                    checked={selected.indexOf(option) > -1}
                    sx={{
                      color: '#45BF9F',
                      '&.Mui-checked': {
                        color: '#45BF9F',
                      },
                    }}
                  />
                </ListItemIcon>
                <ListItemText primary={option} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Divider orientation="vertical" flexItem style={{ marginLeft: "5px" }} />

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 5px 0 10px'
      }}>
        <Tooltip title={'Reset All Filters'} placement='top'>
          <CachedIcon
            style={{ cursor: 'pointer', color: '#17b696', marginLeft: '10px' }}
            onClick={resetFilters}
          />
        </Tooltip>
      </div>
      <Grid item style={{ margin: "10px 0 10px 15px", width: '150px' }}>
        <FormControl size="small" fullWidth>
          <InputLabel id="demo-simple-select-label">Auto Refresh</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Auto Refresh"
            value={autoRefreshTime}
            onChange={(event) => { dispatch(setAutoRefreshTime(event.target.value)) }}
          >
            {
              [{ display: 'Off', value: 0 },
              { display: '5 sec', value: 5 },
              { display: '10 sec', value: 10 },
              { display: '30 sec', value: 30 },
              { display: '1 min', value: 60 },
              { display: '5 min', value: 300 }].map(d =>
                <MenuItem
                  key={d.value}
                  value={d.value}
                  id={d.value}
                >{d.display}</MenuItem>)
            }
          </Select>
        </FormControl>
      </Grid>

    </Paper>
  );
}

export default TopBarFilterOne;